export default __webpack_public_path__ + "static/media/assessment.11af25c0.svg";